import { Button, Modal } from "react-bootstrap";
import React, { useState } from "react";
const testData = [
    { id: 1, name: "Pre-Call Analysis", deadline: "08/07/25", score: "-", status: "TAKE" },
    { id: 2, name: "Opening", deadline: "08/21/25", score: "-", status: "TAKE" },
    { id: 3, name: "Probing", deadline: "08/26/25", score: "-", status: "TAKE" },
    { id: 4, name: "Features & Benefits", deadline: "08/29/25", score: "-", status: "TAKE" },
];
const Test = () => {
    const [showModal, setShowModal] = useState(false);

    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    return (
        <div className="lms-body">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="lms-profile-wrapper mb-0">
                    <span className="lms-profile-name">TEST</span>
                </div>
                <div className="text-end fs-18">
                    <p className="mb-0 fw-semibold">August 2025</p>
                    <p className="mb-0">As of Tuesday, August 19</p>
                </div>
            </div>

            <div className="lms-content-wrapper lms-content-text">
                <div className="lms-course text-end fs-18 fw-600 mb-3 pb-2">
                    Total Courses: 0/7
                </div>
                <div class="lms-table-wrapper overflow-y lms-ceontent-course">
                    <table className="test-table text-center ">
                        <thead>
                            <tr>
                                <th>TEST NAME</th>
                                <th>DEADLINE</th>
                                <th>SCORE</th>
                                <th>STATUS</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {testData.map((test) => (
                                <tr key={test.id}>
                                    <td>{test.name}</td>
                                    <td>{test.deadline}</td>
                                    <td>{test.score}</td>
                                    <td className="status-cell">
                                        <Button
                                            className="status-btn"
                                            variant="secondary"   // change to "danger", "primary", etc. based on status
                                        >
                                            {test.status}
                                        </Button>

                                    </td>
                                    <td onClick={handleOpen}>
                                        Docu
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Modal show={showModal} onHide={handleClose} centered >
                        <Modal.Header closeButton>
                            <Modal.Title as='h5'>Test Attempts</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <table className="text-center">
                                <thead>
                                    <tr>
                                        <th>Date/Time</th>
                                        <th>Attempt #</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>08/07/25 11:00 PM</td>
                                        <td><span class="attempt-badge first-attempt">1st</span></td>
                                        <td class="score-cell score-low">1/5</td>
                                    </tr>
                                    <tr>
                                        <td>08/07/25 1:03 PM</td>
                                        <td><span class="attempt-badge second-attempt">2nd</span></td>
                                        <td class="score-cell score-high">4/5</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>

        </div>

    );
};

export default Test;


